export default "__VITE_ASSET__CPudiPuN__"